import { Component, Inject, OnInit } from '@angular/core';
import { PilotControlledLightingService } from '../service/pilot-controlled-lighting.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditPilotControlledLightingComponent } from '../edit-pilot-controlled-lighting/edit-pilot-controlled-lighting.component';


@Component({
  selector: 'app-delete-pilot-controlled-lighting',
  templateUrl: './delete-pilot-controlled-lighting.component.html',
  styleUrls: ['./delete-pilot-controlled-lighting.component.scss']
})
export class DeletePilotControlledLightingComponent implements OnInit {
  pclId: number;
  airportId: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditPilotControlledLightingComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _pclService: PilotControlledLightingService) {
    this.pclId = data.pclId;
    this.airportId = data.airportId;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._pclService.deletePCL(this.airportId, this.pclId);
      this.isLoading = false;
      this.close({success: true});
    } catch (e) {
      this.close({success: false});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
